<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sales Invoices Report</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/sales-summary">
          <v-icon left>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div>

          <v-row>
            <v-col cols="12">
              <download-excel :data="dailySales" :fields="fields" name="sales report">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>
            </v-col>
          </v-row>
          <v-row dense>
            <!-- excel icon -->

            <!-- end -->
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete autocomplete="off" dense outlined v-model="record.CustomerId" :items="customers"
                label="Customer" item-text="Name" item-value="id"></v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3" v-if="userLoaded && !AmayaVersion">
              <v-autocomplete autocomplete="off" dense outlined v-model="record.SoldBy" :items="users" label="Sold By"
                item-text="name" item-value="id">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-btn class="right" color="primary" :loading="loader" @click="getReport">generate Report</v-btn>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-text-field dense label="Search" v-model="search"></v-text-field>
            </v-col>



            <v-divider></v-divider>

          </v-row>

          <v-row v-if="hideTotals != 'Y'">
            <v-col cols="12" xs="12" md="4" class="subtitle-2 text--primary section-bg mb-2 style-16">
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td><span class="style-18 custom-primary">Total Sales</span></td>
                      <td><span class="style-18 custom-primary">{{ totalSales | currency }}</span></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers" :items="dailySales"
                :search="search">
                <!-- template -->
                <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
                <!-- end -->
                <!-- template -->
                <template v-slot:item.TotalPaid="{ item }">
                  {{
                    item.TotalPaid | currency
                  }}
                </template>
                <!-- end -->
                <!-- template -->
                <template v-slot:item.Balance="{ item }">
                  {{
                    item.Balance | currency
                  }}
                </template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.Date="{ item }">
                  <span>{{ item.Date | date }}</span>
                </template>

                <!-- end -->

                <!-- action template -->
                <template v-slot:item.DocNum="{ item }">
                  <v-btn color="accent" text @click="openSaleDetails(item)">
                    {{ item.DocNum }}
                    <v-icon right>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>

          <v-row>
            <v-divider></v-divider>
          </v-row>

          <v-row  v-if="userLoaded && !AmayaVersion && returnsData.length > 0">
            <v-col cols="12">
              <h3 style="color: red">Cancelled Sales</h3>
            </v-col>

            <v-col cols="12" style="margin-top: -20px">
              <v-data-table :mobile-breakpoint="0" :search="search" :headers="returnHeaders" :items="returnsData">
                <!-- DocNum template -->
                <template v-slot:item.odln="{ item }">
                  <v-btn color="red" text @click="showProducts(item.OdlnId)">
                    <span>{{ item.odln.DocNum }}</span>
                  </v-btn>
                </template>
                <!-- end -->
                <!-- DocTotal template -->
                <template v-slot:item.ocrd="{ item }">
                  <span style="color: red">{{ item.ocrd.Name }}</span>
                </template>
                <!-- end -->
                <!-- DocTotal template -->
                <template v-slot:item.DocTotal="{ item }">
                  <span style="color: red">
                    {{
                      item.DocTotal.toLocaleString()
                    }}
                  </span>
                </template>
                <!-- end -->
                <!-- action template -->
                <template v-slot:item.action="{ item }">
                  <v-btn color="red" text @click="showProducts(item.OdlnId)" icon>
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>

          <!-- products modal -->
          <v-dialog v-model="productsDialog" max-width="800px">
            <v-card>
              <v-toolbar dense color="accent" dark>
                <v-toolbar-title>Sold Products</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="productsDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row dense id="po">
                    <v-col cols="12" xs="12" md="3">
                      <span>Customer: {{ record.ocrd && record.ocrd.Name }}</span>
                    </v-col>

                    <v-col cols="12" xs="12" md="3">Receipt No: {{ record.DocNum }}</v-col>

                    <v-col cols="12" xs="12" md="3">Date: {{ record.DocDate }}</v-col>

                    <v-col cols="12" id="docForm">
                      <v-data-table light :items-per-page="pageItems" :headers="soldHeaders" :items="soldItems"
                        item-key="id" hide-default-footer disable-sort :mobile-breakpoint="zeroValue">
                        <template v-slot:item.Name="{ item }">
                          {{
                            item.Name
                          }}
                        </template>

                        <template v-slot:item.ref1="{ item }">
                          {{
                            item.ref1
                          }}
                        </template>

                        <template v-slot:item.Quantity="{ item }">
                          {{
                            item.Quantity
                          }}
                        </template>

                        <template v-slot:item.Price="{ item }">
                          <span v-if="item.Price">
                            {{
                              item.Price.toLocaleString()
                            }}
                          </span>
                        </template>

                        <template v-slot:item.DiscSum="{ item }">
                          {{
                            item.DiscSum
                          }}
                        </template>

                        <template v-slot:item.DisplayTotal="{ item }">
                          {{
                            item.DisplayTotal
                          }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of products modal -->

          <!-- Cancelled products dialog -->
          <v-dialog v-model="cancelledDialog" max-width="800px">
            <v-card>
              <v-toolbar dense color="accent" dark>
                <v-toolbar-title>Cancelled/Returned Products</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="cancelledDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" xs="12">
                      <h4 style="color: red">Cancelled/Returned products</h4>
                      <v-data-table light :mobile-breakpoint="0" :items-per-page="100" :headers="cancelledHeaders"
                        :items="cancelledData" item-key="id" hide-default-footer>
                        <template v-slot:item.product="{ item }">
                          <span style="color: red">
                            {{
                              item.product.Name
                            }}
                          </span>
                        </template>

                        <template v-slot:item.Quantity="{ item }">
                          <span style="color: red">{{ item.Quantity }}</span>
                        </template>

                        <template v-slot:item.Price="{ item }">
                          <span style="color: red">
                            {{
                              item.Price.toLocaleString()
                            }}
                          </span>
                        </template>

                        <template v-slot:item.LineTotal="{ item }">
                          <span style="color: red">
                            {{
                              item.LineTotal.toLocaleString()
                            }}
                          </span>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of cancelled products modal-->

          <!-- Sale details dialog -->
          <v-dialog v-model="detailsDialog" max-width="1150px" scrollable>
            <v-card class="details-dialog">
              <!-- Hero header -->
              <div class="details-hero">
                <div class="d-flex align-center flex-wrap px-4 py-2">
                  <v-icon color="white" class="mr-2">mdi-receipt-text-outline</v-icon>
                  <span class="white--text font-weight-medium mr-3">
                    Invoice #{{ detailsInvoice && detailsInvoice.DocNum || '—' }}
                  </span>
                  <span class="white--text text-caption mr-3" v-if="detailsInvoice && detailsInvoice.Customer">
                    <v-icon x-small color="white" class="mr-1">mdi-account-circle-outline</v-icon>
                    {{ detailsInvoice.Customer.Name }}
                  </span>
                  <span class="white--text text-caption" v-if="detailsInvoice && detailsInvoice.date">
                    <v-icon x-small color="white" class="mr-1">mdi-calendar-blank-outline</v-icon>
                    {{ detailsInvoice.date | date }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn icon dark small @click="detailsDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>

              <v-card-text class="pa-4">
                <div v-if="detailsLoading" class="text-center py-12">
                  <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                  <div class="mt-3 grey--text">Loading invoice details...</div>
                </div>

                <div v-else>
                  <!-- Stat cards -->
    

                  <!-- Action buttons -->
                  <v-row dense class="mt-2">
                    <v-col cols="12" class="d-flex flex-wrap" style="gap:8px">
                      <v-btn outlined small color="primary" @click="generateDetailsInvoice">
                        <v-icon left small>mdi-file-pdf-box</v-icon>Invoice PDF
                      </v-btn>
                      <v-btn outlined small color="primary" @click="generateDetailsDelivery">
                        <v-icon left small>mdi-truck-delivery-outline</v-icon>Delivery PDF
                      </v-btn>
                    </v-col>
                  </v-row>

                                <v-row dense>
                    <v-col cols="12" sm="4">
                      <v-card outlined class="stat-card stat-total pa-3">
                        <div class="d-flex align-center">
                          <v-avatar color="primary lighten-5" size="40" class="mr-3">
                            <v-icon color="primary">mdi-cash-multiple</v-icon>
                          </v-avatar>
                          <div>
                            <div class="caption grey--text text-uppercase">Total Bill</div>
                            <div class="stat-value">
                              {{ (detailsInvoice && detailsInvoice.DocTotal) | currency }}
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-card outlined class="stat-card stat-paid pa-3">
                        <div class="d-flex align-center">
                          <v-avatar color="green lighten-5" size="40" class="mr-3">
                            <v-icon color="success">mdi-check-decagram</v-icon>
                          </v-avatar>
                          <div>
                            <div class="caption grey--text text-uppercase">Total Paid</div>
                            <div class="stat-value success--text">
                              {{ detailsTotalPaid | currency }}
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-card outlined class="stat-card pa-3" :class="detailsBalance > 0 ? 'stat-balance-due' : 'stat-balance-clear'">
                        <div class="d-flex align-center">
                          <v-avatar :color="detailsBalance > 0 ? 'red lighten-5' : 'grey lighten-3'" size="40" class="mr-3">
                            <v-icon :color="detailsBalance > 0 ? 'error' : 'grey darken-1'">
                              {{ detailsBalance > 0 ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline' }}
                            </v-icon>
                          </v-avatar>
                          <div>
                            <div class="caption grey--text text-uppercase">Balance</div>
                            <div class="stat-value" :class="detailsBalance > 0 ? 'error--text' : 'grey--text text--darken-1'">
                              {{ detailsBalance | currency }}
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Payments (full width) -->
                  <v-row dense>
                    <v-col cols="12">
                      <v-card outlined class="info-card">
                        <div class="section-header d-flex align-center">
                          <v-icon small class="mr-2">mdi-credit-card-outline</v-icon>
                          Payments
                          <v-spacer></v-spacer>
                          <v-chip x-small color="primary" outlined>
                            {{ detailsPayments.length }} {{ detailsPayments.length === 1 ? 'entry' : 'entries' }}
                          </v-chip>
                        </div>

                        <div v-if="!detailsPayments.length" class="text-center py-6 grey--text">
                          <v-icon large color="grey lighten-1">mdi-cash-remove</v-icon>
                          <div class="caption mt-1">No payments recorded</div>
                        </div>

                        <v-list dense v-else class="py-0">
                          <div v-for="(p, index) in detailsPayments" :key="`pay-${index}`">
                            <v-list-item>
                              <v-list-item-avatar size="32" color="primary lighten-5">
                                <v-icon small color="primary">mdi-bank-outline</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-medium">
                                  {{ p.Account && p.Account.Name }}
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="p.PaymentRemarks">
                                  Ref: {{ p.PaymentRemarks }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <span class="success--text font-weight-bold">
                                  {{ p.Amount | currency }}
                                </span>
                              </v-list-item-action>
                            </v-list-item>
                            <v-divider v-if="index < detailsPayments.length - 1"></v-divider>
                          </div>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Sold items -->
                  <v-row dense class="mt-1">
                    <v-col cols="12">
                      <v-card outlined class="info-card">
                        <div class="section-header d-flex align-center">
                          <v-icon small class="mr-2">mdi-cart-outline</v-icon>
                          Sold Items
                          <v-spacer></v-spacer>
                          <v-chip x-small color="primary" outlined>
                            {{ detailsSaleRows.length }} {{ detailsSaleRows.length === 1 ? 'item' : 'items' }}
                          </v-chip>
                        </div>
                        <v-data-table
                          dense
                          light
                          :mobile-breakpoint="0"
                          :items-per-page="100"
                          :headers="detailsHeaders"
                          :items="detailsSaleRows"
                          item-key="id"
                          hide-default-footer
                          class="details-table"
                        >
                          <template v-slot:item.itemCode="{ item }">
                            <span>{{ item.itemCode || (item.product && item.product.ItemCode) }}</span>
                          </template>
                          <template v-slot:item.Name="{ item }">
                            <span>{{ item.product && item.product.Name }}</span>
                          </template>
                          <template v-slot:item.Price="{ item }">
                            <span v-if="item.Price">{{ item.Price | currency }}</span>
                          </template>
                          <template v-slot:item.LineTotal="{ item }">
                            <strong>{{ item.LineTotal | currency }}</strong>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>

                    <v-col cols="12" v-if="detailsOutsourced.length">
                      <v-card outlined class="info-card">
                        <div class="section-header">
                          <v-icon small class="mr-2">mdi-package-variant-closed</v-icon>
                          Outsourced Products
                        </div>
                        <v-data-table
                          light
                          :mobile-breakpoint="0"
                          :items-per-page="100"
                          :headers="detailsOutHeaders"
                          :items="detailsOutsourced"
                          item-key="id"
                          hide-default-footer
                          class="details-table"
                        >
                          <template v-slot:item.Price="{ item }">
                            <span v-if="item.Price">{{ item.Price | currency }}</span>
                          </template>
                          <template v-slot:item.LineTotal="{ item }">
                            <strong>{{ item.LineTotal | currency }}</strong>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>

            <pdf-preview ref="detailsPdfPreview"></pdf-preview>
          </v-dialog>
          <!-- end of sale details dialog -->
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import "export-json-excel";
import { http, host } from "@/common/index";
export default {
  computed: {
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    }
  },
  data() {
    return {
      record: {},
      users: [],
      productsDialog: false,
      salesLoader: false,
      soldItems: [],
      pageItems: 100,
      zeroValue: 0,
      menu1: false,
      menu2: false,
      loader: false,
      search: null,
      customers: [],
      reportData: {},
      TotalReturns: null,
      TotalServices: 0,
      returnsData: [],
      reportDataAllSales: [],
      cancelledDialog: false,
      cancelledData: [],
      drivers: [],
      dailySales: [],
      totalSales: 0,
      totalPayments: 0,
      creditSales: 0,
      AmayaVersion: true,
      userLoaded: false,
      detailsDialog: false,
      detailsLoading: false,
      detailsInvoice: {},
      detailsTotalPaid: 0,
      detailsBalance: 0,
      detailsSaleRows: [],
      detailsOutsourced: [],
      detailsPayments: [],
      detailsHeaders: [
        { text: "Item Code", value: "itemCode" },
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Unit", value: "Unit" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ],
      detailsOutHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Unit", value: "Unit" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ],
      cancelledHeaders: [
        { text: "Product", value: "product" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ],
      soldHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "DisplayTotal" }
      ],
      headers: [
        { text: "Doc Num.", value: "DocNum" },
        { text: "Customer", value: "CustomerName" },
        { text: "Total", value: "DocTotal" },
        { text: "Paid", value: "TotalPaid" },
        { text: "Balance", value: "Balance" },
        { text: "Sale Type", value: "SaleType" },
        { text: "Picked By", value: "PickedBy" },
        { text: "Sold By", value: "SoldBy" },
        { text: "Date", value: "Date" }
      ],
      returnHeaders: [
        { text: "Invoice No.", value: "odln" },
        { text: "Customer", value: "ocrd" },
        { text: "Return Value", value: "DocTotal" },
        { text: "Date", value: "DocDate" },
        { text: "Date", value: "action" }
      ],
      fields: {
        InvoiceNo: "DocNum",
        CustomerName: "CustomerName",
        Total: "DocTotal",
        AmountPaid: "TotalPaid",
        Balance: "Balance",
        Date: "Date"
      },
    };
  },
  methods: {
    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    openProductsModal(val) {
      const self = this;
      this.$store.commit("loader", true);
      self.record = {};
      this.$store
        .dispatch("get", `/documents/14/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.record = res.ResponseData;
            const products = [];
            if (res.ResponseData.rows) {
              for (const row of res.ResponseData.rows) {
                row.Name = row.product.Name;
                row.DisplayTotal = row.LineTotal.toLocaleString();
                products.push(row);
              }
              self.soldItems = products;
              self.productsDialog = true;
              this.$store.commit("loader", false);
            }
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    showProducts(OdlnId) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/cancelled-sale-products/${OdlnId}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.cancelledData = res.ResponseData;
            self.$store.commit("loader", false);
            self.cancelledDialog = true;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getReport() {
      let data = this.record;
      const self = this;
      const url = `/daily-sales-report`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dailySales = res.ResponseData.sales;
            self.totalSales = res.ResponseData.totalSales;
            this.totalPayments = res.ResponseData.totalPayments;
            this.creditSales = res.ResponseData.creditSales;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    print() { },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    exportToExcel() { },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openSaleDetails(item) {
      const self = this;
      this.detailsDialog = true;
      this.detailsLoading = true;
      this.detailsInvoice = {};
      this.detailsTotalPaid = 0;
      this.detailsBalance = 0;
      this.detailsSaleRows = [];
      this.detailsOutsourced = [];
      this.detailsPayments = [];
      this.$store
        .dispatch("get", `/sales-invoice/${item.id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const d = res.ResponseData || {};
            self.detailsInvoice = d.Invoice || {};
            self.detailsTotalPaid = d.TotalPaid || 0;
            self.detailsBalance = d.Balance || 0;
            self.detailsSaleRows = d.SaleRows || [];
            self.detailsOutsourced = d.OutsourcedProducts || [];
            self.detailsPayments = d.Payments || [];
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.detailsLoading = false;
        });
    },
    generateDetailsInvoice() {
      if (!this.detailsInvoice || !this.detailsInvoice.id) return;
      const isDistributor = localStorage.getItem("IsDistributor");
      const url = isDistributor == "Y"
        ? `/print-supermarket-invoice-document/14/${this.detailsInvoice.id}`
        : `/print-sale-invoice-document/14/${this.detailsInvoice.id}`;
      const self = this;
      http.get(`${host}${url}`, { responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(blob);
        self.$refs.detailsPdfPreview.show(fileUrl);
      });
    },
    generateDetailsDelivery() {
      if (!this.detailsInvoice || !this.detailsInvoice.id) return;
      const url = `/print-supermarket-delivery-document/10/${this.detailsInvoice.id}`;
      const self = this;
      http.get(`${host}${url}`, { responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(blob);
        self.$refs.detailsPdfPreview.show(fileUrl);
      });
    },
         getUserDetails() {
      const userId = localStorage.getItem("userId");
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            this.AmayaVersion = res.ResponseData.AmayaVersion == "Y" ? true : false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          this.userLoaded = true;
        })
        .catch((err) => {
          this.userLoaded = true;
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCustomers();
    this.getUsers();
    this.getUserDetails();
  }
};
</script>

<style lang="scss" scoped>
.details-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.details-hero {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  color: #fff;
  position: relative;

  .opacity-80 {
    opacity: 0.85;
    letter-spacing: 1px;
  }
}

.stat-card {
  border-radius: 10px !important;
  border-left: 4px solid transparent !important;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  }

  &.stat-total { border-left-color: #1976d2 !important; }
  &.stat-paid { border-left-color: #4caf50 !important; }
  &.stat-balance-due { border-left-color: #f44336 !important; }
  &.stat-balance-clear { border-left-color: #9e9e9e !important; }
}

.info-card {
  border-radius: 10px !important;
  margin-bottom: 12px;
  overflow: hidden;
}

.section-header {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #455a64;
  background: #f5f7fa;
  padding: 10px 14px;
  border-bottom: 1px solid #eceff1;
}

.info-field {
  padding: 4px 8px;
  border-left: 3px solid #e3f2fd;

  .info-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #90a4ae;
    margin-bottom: 2px;
  }

  .info-value {
    font-size: 14px;
    font-weight: 500;
    color: #37474f;
  }
}

.details-table ::v-deep th {
  background: #fafbfc !important;
  font-weight: 600 !important;
  color: #546e7a !important;
}

.details-table ::v-deep tbody tr:hover {
  background: #f8fafc !important;
}

.details-table ::v-deep tbody td {
  font-weight: 500 !important;
  color: #37474f !important;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: #263238;
}
</style>